module.exports = __webpack_public_path__ + "assets/images/oval-blue.a3ebdd53.svg";